module.exports = __webpack_public_path__ + "img/spjs.f83b0b87.png";